import contentimg from "../media/content.png"

const Websites = ( ) => {
  return (
    <img src={contentimg} style={{objectFit: "contain", width: "100%"}}></img>
  )
}

export default Websites